export default __webpack_public_path__ + "static/media/data-processing.e27b93ce.png";